import PropTypes from "prop-types";
import * as React from "react";
import { FormattedMessage } from "react-intl";
import { SessionStore } from "../uidispatcherapi/SessionStore";
import { MaintenanceMessages } from "./MaintenanceMessage";
import { NotificationsWithReactAdapter } from "./Notifications";
import { withIntlRoot } from "../IntlRootMixin";
import LogoutPopup from "./LogoutPopup";
import ErrorPage from "./ErrorPage";
import CountryUtil from "../uidispatcherapi/CountryUtil";
import { ForceReloadStore } from "../stores/ForceReloadStore";
import BrowserSupportPopup from "./BrowserSupportPopup";
import FooterActions from "../actions/FooterActions";
import HeaderActions from "../actions/HeaderActions";
import { wrapLazyComponent } from "../lazy-loading/lazyWrapper";
import history from "../uidispatcherapi/BettyHistoryModule";
import PageHeader from "./PageHeader";
import { PageBottom } from "./PageBottom";
import { Modal, ModalContent } from "@metro-ui/core";

const HeaderEmployee = wrapLazyComponent(() => import("explore_ui/HeaderEmployee"));
const forceReloadStore = new ForceReloadStore();
forceReloadStore.checkForForceReload().catch(error => console.error(error));

type AppProps = {
	history: any;
	location: any;
	children: React.ReactNode;
};
type AppState = {
	displayForceReloadNotification: boolean;
	errorOccurred: boolean;
	error: Record<string, any>;
	errorInfo: Record<string, any>;
};

class AppComponent extends React.Component<AppProps, AppState> {
	static readonly contextTypes = {
		router: PropTypes.object,
	};
	static readonly childContextTypes = {
		location: PropTypes.object,
		history: PropTypes.object,
	};

	constructor(props: AppProps) {
		super(props);
		this.state = {
			displayForceReloadNotification: forceReloadStore.isReloadPending(),
			errorOccurred: false,
			error: {},
			errorInfo: {},
		};
	}

	getChildContext() {
		return {
			location: this.props.location,
			history: this.props.history,
		};
	}

	componentDidCatch(error, errorInfo) {
		console.error(error, errorInfo);
		this.setState({
			errorOccurred: true,
			errorInfo: errorInfo,
			error: error,
		});
	}

	componentDidMount() {
		const root = document.getElementsByTagName("html")[0];
		const country = SessionStore.getCountry();

		if (country) {
			root.classList.add("co-" + country.toLowerCase());
		}

		const locale = SessionStore.getLocale();

		if (locale) {
			root.classList.add("lo-" + locale.toLowerCase());
		}

		forceReloadStore.listen(() =>
			this.setState({
				displayForceReloadNotification: forceReloadStore.isReloadPending(),
			}),
		);
	}

	componentDidUpdate() {
		FooterActions.updateFooter();
		HeaderActions.updateHeader();
	}

	renderApp() {
		if (this.state.errorOccurred) {
			return <ErrorPage error={this.state.error} errorInfo={this.state.errorInfo} />;
		}

		const header = <div>{HeaderEmployee ? <HeaderEmployee /> : <div />}</div>;
		const sessionId = SessionStore.getClientSessionId();

		if (SessionStore.pending()) {
			// not rendering because still pending (TODO(EP) could do without?)
			return (
				<div className="loading-message">
					<FormattedMessage id="PL_LOADING" />
				</div>
			);
		}

		return (
			<div>
				{header}
				<div className="hidden test-session-id" title={sessionId} />
				<NotificationsWithReactAdapter />
				<Modal isOpen={this.state.displayForceReloadNotification} zIndex={1050} padding="medium">
					<ModalContent>
						<FormattedMessage id="PL_FORCE_RELOAD_PENDING" />
					</ModalContent>
				</Modal>
				{this.props.children}
				<LogoutPopup />
				<MaintenanceMessages maintenance_messages={CountryUtil.getOptionalConfig().maintenance_messages} />
				<BrowserSupportPopup />
			</div>
		);
	}

	render() {
		return (
			<>
				<PageHeader history={history.get()} />
				{this.renderApp()}
				<PageBottom />
			</>
		);
	}
}

export const App = withIntlRoot(AppComponent);
